module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/89a8b5301a7935918b0e312790d28017.png";